exports.ISFRenderer = require("./lib/ISFRenderer.js").ISFRenderer;
exports.ISFParser = require("./lib/ISFParser.js").ISFParser;
